import { ColumnDef, Row } from '@tanstack/react-table'
import { useMemo } from 'react'
import { TextCell } from '@pages/Admin/Reports/Payments/components/Cells/Cells'
import { IFinancialTransactionsReportItem } from '../utils/types'

interface TableColumnsProps {}

const useTableColumns = () => {
  return useMemo<ColumnDef<IFinancialTransactionsReportItem>[]>(() => {
    const allColumns = [
      {
        header: '',
        id: 'index',
        size: 50,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell
            text={((row.original.index ?? 0) + 1)?.toString() ?? '-'}
            styles={{ textAlign: 'center' }}
          />
        ),
      },
      {
        header: 'Курс',
        id: 'course',
        size: 250,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell
            text={row.original.course ?? '-'}
            styles={{
              width: '100%',
              textAlign: 'start',
            }}
          />
        ),
      },
      {
        header: 'Сумма',
        id: 'amount',
        size: 100,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={String(row.original.amount ?? '-')} />
        ),
      },
      {
        header: 'Дата',
        id: 'date',
        size: 100,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={row.original.date ?? '-'} />
        ),
      },
      {
        header: 'Продлено на',
        id: 'accessExtendedBy',
        size: 150,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={row.original.accessExtendedBy ?? '-'} />
        ),
      },
      {
        header: 'Оплачено с',
        id: 'paidFrom',
        size: 100,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={row.original.paidFrom ?? '-'} />
        ),
      },
      {
        header: 'Оплачено до',
        id: 'paidTo',
        size: 100,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={row.original.paidTo ?? '-'} />
        ),
      },
      {
        header: 'Формат оплаты',
        id: 'paymentFormat',
        size: 150,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={row.original.paymentFormat ?? '-'} />
        ),
      },
      {
        header: 'Статус',
        id: 'status',
        size: 100,
        cell: ({ row }: { row: Row<IFinancialTransactionsReportItem> }) => (
          <TextCell text={row.original.status ?? '-'} />
        ),
      },
    ]

    return allColumns
  }, [])
}

export default useTableColumns
